"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dialogStyles = exports.containerStyles = void 0;
exports.containerStyles = {
    opacity: 0,
    position: "fixed",
    top: 0,
    left: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100vw",
    height: "calc(var(--fusion-vh, 1vh) * 100)"
};
exports.dialogStyles = {
    transform: "scale(0.25)",
    cursor: "default"
};
